{phoneValidator, emailValidator, requiredFieldValidator} = require 'utils/validations'
validator = require 'utils/validate'


App.DeliveryCouriersEditController = Em.Controller.extend
  notifier: Em.inject.service()
  env:      Em.inject.service('environment')
  session:  Em.inject.service('session')

  needs: [ 'deliveryCouriers' ]

  courierBinding:  'model'
  couriersBinding: 'controllers.deliveryCouriers.model.couriers'
  restaurantsBinding: 'controllers.deliveryCouriers.model.restaurants'

  isSaving: false

  errors: {}

  actions:
    deleteCourier: ->
      courier = @get('courier')


      if confirm Em.I18n.t('courier.confirms.delete')
        courier.destroyRecord()
        .then =>
          @get('notifier').pushNotification
            type: 'success'
            title: Em.I18n.t('courier.alerts.delete.title')
            message: Em.I18n.t('courier.alerts.delete.message')
            duration: 3000
          @controllerFor('delivery.couriers').set('couriers', @get('couriers').removeObject(courier))
          @transitionToRoute('delivery.couriers')
        .catch (xhr) =>
          @get('notifier').pushNotification
            type: 'error'
            title: Em.I18n.t('courier.alerts.error.title')
            message: xhr.responseJSON.error
          false
        .finally =>
          @set('isSaving', false)


    saveCourier: ->
      courierPhone = @get('courier.phone')
      courierEmail = @get('courier.login')

      currentErrors = validator.useValidation({
        phone: courierPhone,
        login: courierEmail
      }, ()=> ({
        phone: [phoneValidator(), requiredFieldValidator()],
        login: [emailValidator(), requiredFieldValidator()]
      }))()
      @set('errors', currentErrors)
      return if Object.values(currentErrors).length

      return if @get('isSaving')
      courier = @get('courier')
      
      @set('isSaving', true)
      courier.save()
      .then =>
        @controllerFor('delivery.couriers').set('couriers', @get('couriers').addObject(courier))
        @get('notifier').pushNotification
          type: 'success'
          title: Em.I18n.t('courier.alerts.success.title')
          message: Em.I18n.t('courier.alerts.success.message')
          duration: 3000
        @transitionToRoute('delivery.couriers')
      .catch =>
        false
      .finally =>
        @set('isSaving', false)

        # Разбираем ошибки валидации
        validationErrors = courier.get('errors')

        [ 'login', 'password', 'name' ].forEach (field) =>
          validationField = "errors.#{field}"
          if validationErrors.has(field)
            message = validationErrors.errorsFor(field).map (m) ->
              m.message
            .join(',')

            @set(validationField, message)
          else
            @set(validationField, null)

        courier.set('password', null)
        courier.set('password_confirmation', null)

    cancel: ->
      courier = @get('courier')
      if confirm Em.I18n.t 'settings.business_role.cancel'
        courier.rollback()
        @transitionToRoute('delivery.couriers')

    ###
    # Назад
    ###
    goBackToCouriersList: ->
      @transitionToRoute('delivery.couriers')
      false
